module.exports = __webpack_public_path__ + "img/cnbv.6c067e3b.svg";